export var timeIsLessThanGap = function timeIsLessThanGap() {
  var gap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 60;
  var dateA = arguments.length > 1 ? arguments[1] : undefined;
  var dateB = arguments.length > 2 ? arguments[2] : undefined;
  var seconds = Math.floor((dateB - dateA) / 1000);
  return seconds <= gap;
};